export default [
    {
        path: '/consultingcategory',
        name: 'consultingcategory',
        component: () => import('@/views/menu/consulting/consultingcategory.vue'),
        meta: {
            pageTitle: 'مدیریت دسته بندی ها',
            action: 'show',
            resource: 'ConsultingCategoryManager',
        },
    },
    {
        path: '/consultingprofile',
        name: 'consultingprofile',
        component: () => import('@/views/menu/consulting/consultingprofile.vue'),
        meta: {
            pageTitle: 'مدیریت مشاوران',
            action: 'show',
            resource: 'ConsultingProfileManager',
        },
    },
    {
        path: '/consultingbooking',
        name: 'consultingbooking',
        component: () => import('@/views/menu/consulting/consultingbooking.vue'),
        meta: {
            pageTitle: 'رزروهای مشاوره',
            action: 'show',
            resource: 'ConsultingProfileManager',
        },
    },
    {
        path: '/consultingreview',
        name: 'consultingreview',
        component: () => import('@/views/menu/consulting/consultingreview.vue'),
        meta: {
            pageTitle: 'نظرات مشاوران',
            action: 'show',
            resource: 'ConsultingProfileManager',
        },
    },
]
